import { LoginEntrypointParams, SessionService } from '../session.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TwoWayConversationService } from '@app/core/services/two-way-conversation.service';
import { TimeOutLocalStorageService } from '@app/core/services/timeOutLocalStorage.service';
import { SpinnerComponent } from '@app/shared/spinner/spinner.component';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: true,
  imports: [SpinnerComponent],
})
export class LogoutComponent implements OnInit {
  constructor(
    private sessionService: SessionService,
    private activatedRoute: ActivatedRoute,
    private twoWayConversationService: TwoWayConversationService,
    private timeOutLocalStorageService: TimeOutLocalStorageService,
  ) { }

  ngOnInit() {
    this.timeOutLocalStorageService.deleteTimeoutValue();
    this.twoWayConversationService
      .shutdownChatClient()
      .then(() => {
        this.sessionService.logout();
        this.sessionService.redirectToBackendLogout(this.getLoginParams());
      })
      .catch(() => {
        this.twoWayConversationService.killChatClient();
        this.sessionService.logout();
        this.sessionService.redirectToBackendLogout(this.getLoginParams());
      });
  }

  private getLoginParams(): LoginEntrypointParams {
    const queryParams = this.activatedRoute.snapshot.queryParams || {};
    return {
      returnUrl: queryParams['returnUrl'],
      invitation: queryParams['invitation'],
      organization: queryParams['organization'],
      organization_name: queryParams['organization_name'],
    };
  }
}
